<template>
    <div id="content">
        <div class="valign-wrapper">
            <h5 class="teal-text">Saindo do sistema. <small>Você será redirecionado para a página de login.</small></h5>
        </div>
    </div>
</template>

<script>
export default {
    name: 'logout',
    mounted() {
        window.localStorage.removeItem('user-token');

        setTimeout(() => {
            this.$router.push('/login');
        }, 3000);
    }
}
</script>

<style lang="scss" scoped>
    #content {
        height: 100vh;
    }
</style>





// WEBPACK FOOTER //
// src/components/logout/Logout.vue